import axiosInstance from "../services/axiosInstance";

/* =========================
   TIMEZONE
========================= */
export const getTimeZones = async (search = "") => {
  try {
    const response = await axiosInstance.get(
      `../select2/timezone?search=${search}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

/* =========================
   COUNTRIES
========================= */
export const getCountries = async (search = "") => {
  try {
    const response = await axiosInstance.get(
      `../select2/countries?search=${search}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

/* =========================
   STATES (by country)
========================= */
export const getStates = async (countryId, search = "") => {
  try {
    const response = await axiosInstance.get(
      `../select2/states?id_country=${countryId}&search=${search}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

/* =========================
   CITIES (by state)
========================= */
export const getCities = async (stateId, search = "") => {
  try {
    const response = await axiosInstance.get(
      `../select2/cities?province=${stateId}&search=${search}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

/* =========================
   COMPANY TYPES
========================= */
export const getCompanyTypes = async (search = "") => {
  try {
    const response = await axiosInstance.get(
      `../select2/types?search=${search}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

/* =========================
   COMPANY TYPES
========================= */
export const getCurrencies = async (search = "") => {
  try {
    const response = await axiosInstance.get(
      `../select2/currencies?search=${search}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
